// extracted by mini-css-extract-plugin
export default {"svgFooter":"Footer_svgFooter__r+zxv","container":"Footer_container__CmmG-","column":"Footer_column__1MrEl","bottom":"Footer_bottom__lzFqe","logo":"Footer_logo__GkEml"};